
import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { uploadImageForEditor } from "../../functions/posts";
function Editors({ value, onEditorStateChange, bio, onKeyUp }) {
  return (
    <div>
      <Editor
        apiKey="79l3rggwxvkvsftbrrw7quops2nk8pksqj4og3ia7j747qr0"
        value={value}
        init={{
          height: 500,
          plugins: [
            "advlist lists link image charmap print preview anchor paste help wordcount emoticons imagetools media codesample code",
          ],
          codesample_languages: [
            { text: 'HTML/XML', value: 'markup' },
            { text: 'JavaScript', value: 'javascript' },
            { text: 'CSS', value: 'css' },
            { text: 'PHP', value: 'php' },
            { text: 'Ruby', value: 'ruby' },
            { text: 'Python', value: 'python' },
            { text: 'Java', value: 'java' },
            { text: 'C', value: 'c' },
            { text: 'C#', value: 'csharp' },
            { text: 'C++', value: 'cpp' }
          ],
          branding: false,
          automatic_uploads: true,
          file_picker_types: 'image',
          file_picker_callback: function (cb, value, meta) {
            console.log(cb, value, meta)
            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.onchange = function () {
              var file = this.files[0];

              var reader = new FileReader();
              reader.readAsDataURL(file);
              uploadImageForEditor(file)
              .then((res) => {
                console.log(res)
                cb(res.data, { title: file.name });
              })
              .catch((err) => {
                console.log(err)
              })
            };

            input.click();
          },
          menubar: 'favs file edit view insert format tools table help',
          toolbar:
            "undo redo | link image | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | emoticons | media | codesample code",
        }}
        onEditorChange={(newvalue, editor) => {
          onEditorStateChange(newvalue, editor.getContent({ format: "html" }));
        }}

      />
    </div>
  );
}
export default Editors;